var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.5v6a2 2 0 01-2 2H3a2 2 0 01-2-2v-11a2 2 0 012-2h6m4-3h6m0 0v6m0-6l-11 11",
    stroke: "#1C1C1F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMCAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2IDExLjVWMTcuNUMxNiAxOC4wMzA0IDE1Ljc4OTMgMTguNTM5MSAxNS40MTQyIDE4LjkxNDJDMTUuMDM5MSAxOS4yODkzIDE0LjUzMDQgMTkuNSAxNCAxOS41SDNDMi40Njk1NyAxOS41IDEuOTYwODYgMTkuMjg5MyAxLjU4NTc5IDE4LjkxNDJDMS4yMTA3MSAxOC41MzkxIDEgMTguMDMwNCAxIDE3LjVWNi41QzEgNS45Njk1NyAxLjIxMDcxIDUuNDYwODYgMS41ODU3OSA1LjA4NTc5QzEuOTYwODYgNC43MTA3MSAyLjQ2OTU3IDQuNSAzIDQuNUg5TTEzIDEuNUgxOU0xOSAxLjVWNy41TTE5IDEuNUw4IDEyLjUiIHN0cm9rZT0iIzFDMUMxRiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgExternalLink as ReactComponent };